export default __webpack_public_path__ + "static/media/unnamed.4f3b839f.png";